module.exports = __webpack_public_path__ + "img/defkf6.8fe28e04.png";